import "./App.css";
import "./STYLE/Menu.css";
import React from "react";
import Container from "react-bootstrap/Container";
import { Route, Switch } from "react-router-dom";

import fb from "./MODELS/FirebaseModule";

import Test from "./VIEWS/Test";
import Upload from "./VIEWS/Upload";
import Answer from "./VIEWS/Answer";
import Help from "./VIEWS/Help";
import Feedback from "./VIEWS/Feedback";
import Default from "./VIEWS/Default";
import Stats from "./VIEWS/Stats";
import Message from "./VIEWS/Message";
import Menu from "./VIEWS/Menu";
import SignIn from "./VIEWS/SignIn";

import { useAuthState } from "react-firebase-hooks/auth";

const auth = fb.auth();

function App() {
  // login

  const [user] = useAuthState(auth);
  if (user) {
    return (
      <Container>
        <Menu />
        <div className="content">
          <Switch>
            <Route exact path="/" component={Default}></Route>
            <Route path="/Message" component={Message}></Route>
            <Route path="/Upload" component={Upload}></Route>
            <Route path="/Answer" component={Answer}></Route>
            <Route path="/Test" component={Test}></Route>
            <Route path="/Help" component={Help}></Route>
            <Route path="/Feedback" component={Feedback}></Route>
            <Route path="/Stats" component={Stats}></Route>
          </Switch>
        </div>
      </Container>
    );
  } else {
    return (
      <div>
        <SignIn />
      </div>
    );
  }
}
export default App;
